module.exports = __webpack_public_path__ + "img/img_dmain3.ad28f90b.jpg";